// extracted by mini-css-extract-plugin
export default {"card":"CreateEvent_card__owXWN","container":"CreateEvent_container__Wihjs","content":"CreateEvent_content__YoNXC","btn":"CreateEvent_btn__g9DBK"};